/* istanbul ignore file */

export const SEARCH_TERM_PREFIX = 'You searched for';
